import { Autocomplete, Box, TextField } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormState } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/components/Arrival/AgentArrivalHypothesisModal/AgentArrivalForm';

type Props = {
    echelonList: string[];
    formState: FormState;
    setFormState: React.Dispatch<React.SetStateAction<FormState>>;
};

export default function EchelonSelector({
    echelonList,
    formState,
    setFormState,
}: Props): React.ReactElement {
    const { t } = useTranslation();

    return (
        <Box sx={{ width: '100%' }}>
            <Autocomplete
                options={Array.from(new Set(echelonList))}
                noOptionsText={t('humanResources.simulation.noOptions')}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={t('humanResources.simulation.addAgent.echelon')} //
                        required
                    />
                )}
                value={formState.echelon}
                onChange={(_, newValue) => {
                    setFormState({
                        ...formState,
                        echelon: newValue ?? '0',
                    });
                }}
            />
        </Box>
    );
}
